export const UploadStatusEnum = {
  QUEUED: "QUEUED",
  STARTED: "STARTED",
  INPROGRESS: "INPROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  PAUSED: "PAUSED",
  PAUSING: "PAUSING",
  CANCELLING: "CANCELLING",
  NONE : ""
}

export const ZIP_MIME_TYPES = [
  "application/x-zip", "application/x-zip-compressed", "application/octet-stream",
  "application/x-compress", "application/x-compressed", "multipart/x-zip", "application/zip"
]

export const PDF_MIME_TYPES = [
  "application/pdf"
]
